export function loadImageFromUrl(url: string) {
  const imgElement = new Image();

  return new Promise<HTMLImageElement>((resolve, reject) => {
    imgElement.onload = () => {
      setTimeout(() => {
        resolve(imgElement);
      }, 0);
    };

    imgElement.onerror = () => {
      reject();
    };

    imgElement.src = url;
  });
}
